import { useQuery } from '@apollo/client';
import React from 'react';

import { JOB_OUTREACH_SCHEDULES, JobOutreachSchedule } from '../graphql/queries/outreach';
import { useSession } from '../hooks/use-session';
import { OutreachSchedulesDataPanel, ScheduleRowData } from './outreach-schedules-data-panel';

export const JobOutreachSchedules: React.FC<{ jobId: string }> = ({ jobId }) => {
    const { user } = useSession();
    const { data } = useQuery<{ jobOutreachSchedules: JobOutreachSchedule[] }>(JOB_OUTREACH_SCHEDULES, {
        variables: { where: { jobId: { _eq: jobId } } }
    });

    const schedules = data?.jobOutreachSchedules || [];
    const userSchedule = schedules.find((schedule) => schedule.userId === user.id);

    const newScheduleTemplate: ScheduleRowData | undefined = userSchedule
        ? undefined
        : {
              count: 50,
              frequencyDays: 1,
              isActive: undefined,
              jobId,
              lastScheduledAt: 0,
              user: {
                  id: user.id,
                  name: user.name.full,
                  username: user.username
              },
              userId: user.id
          };

    return <OutreachSchedulesDataPanel jobId={jobId} newScheduleTemplate={newScheduleTemplate} showStats={false} />;
};
